<template>
  <div v-show="activated > 1" class="relative mt-2">
    <div v-if="isMobile" class="border-2">
      <select
        name="questionfilters"
        id="questionfilters"
        class="block appearance-none leading-tight w-full text-xs font-we pl-2 pr-8 py-1 rounded-full focus:outline-none bg-black text-white"
        :class="chosen > -1 && activated ? 'active' : 'bg-black text-white'"
        @change="chooseFilter"
      >
        <option value="" selected disabled hidden
          >Choose {{ filterName[activated] }}</option
        >
        <option
          v-for="(filter, index) in getFilter"
          :value="index"
          :key="index"
          :class="index === chosen ? 'bg-white' : 'bg-black text-white'"
        >
          {{ filter }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
        :class="activated && chosen > -1 ? 'text-black' : 'text-white'"
      >
        <svg
          class="fill-current h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
    <div v-else v-show="showFilters" class="grid grid-cols-4 gap-3">
      <button
        v-for="(filter, index) in getFilter"
        class="leading-tight text-lg h-16 px-2 py-1 rounded-full focus:outline-none bg-black text-white"
        :class="
          chosen === index && activated > 1 ? 'active' : 'bg-black text-white'
        "
        :key="index"
        @click="chooseFilter(index)"
      >
        {{ filter }}
      </button>
    </div>
  </div>
</template>

<style scoped>
/* select {
  width: 100%;
} */
.active {
  background: rgba(97, 211, 155, 1);
  color: black;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import { Navigation } from "../models";

export default {
  props: {
    isMobile: Boolean,
  },
  computed: {
    ...mapGetters([
      "getQuestionFilters",
      "getGenerationFilters",
      "getGenderFilters",
      "getDisciplineFilters",
      "getActiveNavigation",
    ]),
    activated() {
      return this.getActiveNavigation;
    },
    getFilter() {
      const index = this.getActiveNavigation;
      switch (index) {
        case 2:
          return this.getQuestionFilters;
        case 3:
          return this.getGenerationFilters;
        case 4:
          return this.getGenderFilters;
        case 5:
          return this.getDisciplineFilters;
        default:
          return this.getQuestionFilters;
      }
    },
  },
  data() {
    return {
      chosen: -1,
      filterName: {
        2: "Question",
        3: "Generation",
        4: "Gender",
        5: "Discipline",
      },
      showFilters: true,
    };
  },
  watch: {
    getActiveNavigation(newValue) {
      if (newValue > 1) this.chosen = -1;
    },
    $route(to, from) {
      this.showFilters = to.name !== Navigation.VideoView;
    },
  },
  methods: {
    ...mapMutations(["activeFilter"]),
    resetChosen() {},
    chooseFilter(event) {
      const currentFilter = this.activated;
      if (this.isMobile) this.chosen = event.target.selectedOptions[0].value;
      else this.chosen = this.chosen === event ? -1 : event;
      this.activeFilter(this.chosen);
    },
  },
};
</script>
